var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "news-main-header row" }, [
    _c(
      "div",
      { staticClass: "news-search-wrapper col-12 col-md-4 pb-3" },
      [
        _c("p", { staticClass: "news-filter-header" }, [
          _vm._v("Search by name")
        ]),
        _vm._v(" "),
        _c("search-small", {
          ref: "newsSearchBox",
          attrs: { placeholder: "Search by name" },
          on: { "on-keyup": _vm.onSearchTermChanged, "on-enter": _vm.search }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "news-date-picker-wrapper col-12 col-md-3 pb-3" },
      [
        _c("p", { staticClass: "news-filter-header" }, [_vm._v("Date")]),
        _vm._v(" "),
        _c("date-picker", {
          attrs: {
            "data-vv-validate-on": "input",
            label: "Select time frame",
            "max-date": _vm.currentDate,
            range: true
          },
          model: {
            value: _vm.selectedDate,
            callback: function($$v) {
              _vm.selectedDate = $$v
            },
            expression: "selectedDate"
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "news-category-wrapper col-12 col-md-3 pb-3" }, [
      _c("p", { staticClass: "news-filter-header" }, [_vm._v("Category")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "category-select" },
        [
          _c("model-list-select", {
            attrs: {
              "option-value": "value",
              "option-text": "text",
              list: _vm.categories,
              placeholder: "Select an option"
            },
            on: { input: _vm.onCategoryChanged },
            model: {
              value: _vm.selectedCategory,
              callback: function($$v) {
                _vm.selectedCategory = $$v
              },
              expression: "selectedCategory"
            }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "buttons-wrapper col-12 col-md-2 pb-3" }, [
      _c("div", { staticClass: "search-button-wrapper" }, [
        _c(
          "div",
          {
            staticClass: "homebase-btn-primary mt-4 ml-md-4",
            on: { click: _vm.search }
          },
          [_vm._v("\n        Search\n      ")]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "reset-button-wrapper" }, [
        _c("a", { on: { click: _vm.reset } }, [_vm._v("Clear")])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-39e62e6d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39e62e6d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homebase/news/NewsFeedFilters.vue
// module id = null
// module chunks = 